import { render, staticRenderFns } from "./SpTwoModule4.vue?vue&type=template&id=18ef5282&scoped=true"
import script from "./SpTwoModule4.vue?vue&type=script&lang=js"
export * from "./SpTwoModule4.vue?vue&type=script&lang=js"
import style0 from "./SpTwoModule4.vue?vue&type=style&index=0&id=18ef5282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ef5282",
  null
  
)

export default component.exports